import { actionGenerator } from "./../../Utils/createAuxilaryActions"

export const newAppointmentConsts = {
    SELECT_SLOT: 'NA/SELECT_SLOT',
    SELECT_MENTEES:'NA/SELECT_MENTEES',
    MENTOR:'NA/MENTOR'
}


const [
    selectSlot,
    selectMentees,
    appMentor
] = actionGenerator(Object.values(newAppointmentConsts))

export {selectSlot,selectMentees,appMentor}

